import { chakra } from "@chakra-ui/react";

import { VBabyColors } from "../../colors";
import { EMOTION_PANEL_BG } from "../../theme";

export {
  Card,
  PrimaryButton,
  SecondaryButton,
  Shell,
} from "../../components/vbaby";

export const Page = chakra("div", {
  base: { minHeight: "100vh", background: "vbaby.canvas" },
});

export const Panel = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "20px 24px",
    background: EMOTION_PANEL_BG,
    color: "white",
  },
});

export const PanelCentered = chakra(Panel, {
  base: {
    alignItems: "center",
    gap: "12px",
    padding: "32px 24px",
    textAlign: "center",
  },
});

export const PanelTitle = chakra("h1", {
  base: {
    margin: 0,
    fontFamily: "heading",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "24px",
  },
});

export const PanelSubtitle = chakra("p", {
  base: {
    margin: 0,
    fontFamily: "body",
    fontSize: "13px",
    lineHeight: "18px",
    color: VBabyColors.primary20,
  },
});

export const SuccessCircle = chakra("div", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "56px",
    height: "56px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "rgba(205, 249, 232, 0.35)",
    borderRadius: "full",
    background: "rgba(205, 249, 232, 0.16)",
    color: "vbaby.mint",
  },
});

export const Body = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "20px 16px 24px",
    lg: { padding: "28px" },
  },
});

export const ApprovalSeal = chakra("p", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    margin: 0,
    padding: "8px",
    borderRadius: "10px",
    background: "vbaby.mint",
    color: "vbaby.label",
    fontFamily: "body",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    "& > svg": { flexShrink: 0 },
  },
});

export const PixLayout = chakra("div", {
  base: {
    display: "grid",
    gap: "16px",
    justifyItems: "center",
    lg: {
      gridTemplateColumns: "auto 1fr",
      gap: "28px",
      alignItems: "center",
      justifyItems: "stretch",
    },
  },
});

export const QrFrame = chakra("div", {
  base: {
    display: "flex",
    padding: "8px",
    borderRadius: "10px",
    background: "white",
    boxShadow: "0 4px 16px rgba(93, 77, 235, 0.12)",
  },
});

export const PixInstructions = chakra("div", {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    minWidth: 0,
  },
});

export const ScanTitle = chakra("h2", {
  base: {
    margin: 0,
    fontFamily: "heading",
    fontSize: "15px",
    fontWeight: "600",
    lineHeight: "20px",
    color: "vbaby.ink",
  },
});

export const ScanHint = chakra("p", {
  base: {
    margin: 0,
    fontFamily: "body",
    fontSize: "12.5px",
    lineHeight: "18px",
    color: "vbaby.text2",
  },
});

export const CodeBox = chakra("p", {
  base: {
    overflow: "hidden",
    margin: 0,
    padding: "9px 12px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "vbaby.border",
    borderRadius: "10px",
    background: "vbaby.lilac",
    color: "vbaby.text2",
    fontFamily: "mono",
    fontSize: "11px",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});

export const WaitingLine = chakra("p", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    margin: 0,
    fontFamily: "body",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    color: "vbaby.text3",
    textAlign: "center",
  },
});

export const WaitingDot = chakra("span", {
  base: {
    flexShrink: 0,
    width: "8px",
    height: "8px",
    borderRadius: "full",
    background: "vbaby.purple",
    animation: "vbabyPulse 1.4s ease-in-out infinite",
  },
});

export const InfoText = chakra("p", {
  base: {
    margin: 0,
    fontFamily: "body",
    fontSize: "13.5px",
    lineHeight: "20px",
    color: "vbaby.text2",
  },
});

export const Field = chakra("div", {
  base: { display: "flex", flexDirection: "column", gap: "6px" },
});

export const FieldLabel = chakra("p", {
  base: {
    margin: 0,
    fontFamily: "body",
    fontSize: "12.5px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "vbaby.label",
  },
});

export const ReadOnlyCode = chakra("input", {
  base: {
    boxSizing: "border-box",
    width: "100%",
    padding: "11px 12px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "vbaby.border",
    borderRadius: "10px",
    background: "vbaby.lilac",
    color: "vbaby.text2",
    fontFamily: "mono",
    fontSize: "11px",
    textAlign: "center",
  },
});

export const Barcode = chakra("svg", {
  base: { width: "100%", height: "auto" },
});

export const SecondaryRow = chakra("div", {
  base: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" },
});

export const LiveRegion = chakra("span", {
  base: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: 0,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
  },
});
